import PropTypes from 'prop-types';
import React from 'react';

import { Card } from 'components/AORedesign';
import { Feature } from 'components/Feature';
import EditUser from './views/EditUser';

const UserAdminEditUser = ({ title, username }) => {
  return (
    <Feature allowed={'agencySecurityUserAdministration'}>
      <Card>
        <EditUser title={title} username={username} />
      </Card>
    </Feature>
  );
};

UserAdminEditUser.propTypes = {
  title: PropTypes.string,
  username: PropTypes.string,
};

export default UserAdminEditUser;
